import React from 'react';
import PropTypes from 'prop-types';
import { Label, SmallLabel } from './styles';
import { Tip } from 'modules/common/components';
const propTypes = {
  children: PropTypes.node.isRequired,
  ignoreTrans: PropTypes.bool,
  toolTip: PropTypes.string,
};

function ControlLabel(props, { __ }) {
  const { children, ignoreTrans, required, size, style, ...extraProps } = props;
  if (props.toolTip && props.toolTip !== '') {
    return (
      <Tip text={props.toolTip}>
        <Label>{ignoreTrans ? children : __(children)}</Label>
      </Tip>
    );
  } else if (size === 'small') {
    return <SmallLabel {...extraProps} style={{ ...style }}>{children}
      {(required || props.labelRequired) && <span> *</span>}
    </SmallLabel>;
  } else {
    return (
      <Label {...props}>
        {children}
        {(required || props.labelRequired) && <span> *</span>}
      </Label>
    );
  }
}

ControlLabel.propTypes = propTypes;
ControlLabel.contextTypes = {
  __: PropTypes.func,
};

export default ControlLabel;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/form/Label.js